import { createUseStyles } from 'react-jss';

export default createUseStyles({
  columnsWrapper: {
    paddingRight: 15
  }
});
